import { Transform } from "class-transformer";
import { IsNotEmpty, ValidateIf, Validate, IsEmail, IsBoolean, ValidationArguments } from "class-validator";
import { PhoneValidatorConstraint } from '../validators/phone.validator';
import { Address } from "./address.model";
import { IdentityCardConstraint } from "../validators/ic-validator";
import { IsFileValid } from "../validators/file-upload.validator";


export class AuthorisedRepresentative extends Address {

    constructor(role) {
        super();
        this.role = role;

        if (this.role == 'd' || this.role == 'd&s' || this.role == 'ar')
            this.type = 'individual'

    }

    @IsFileValid({
        message: (args: ValidationArguments) => {
            const obj = args.object as AuthorisedRepresentative;
            return obj.is_malaysian ? 'validation.please_upload_your_front_nric' : 'validation.please_upload_your_passport';
        }
    })
    imageFront: object;

    @ValidateIf(o => o.is_malaysian === true)
    @IsFileValid({ message: 'validation.please_upload_your_back_nric' })
    imageBack: object;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @IsNotEmpty({ message: 'validation.first_name_should_not_be_empty' })
    first_name: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @IsNotEmpty({ message: 'validation.last_name_should_not_be_empty' })
    last_name: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @IsNotEmpty({ message: 'validation.id_number_should_not_be_empty' })
    id_number: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @ValidateIf(o => o.is_malaysian === false)
    @IsNotEmpty({ message: 'validation.passport_expiry_date_should_not_be_empty' })
    passport_expiry_date: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @ValidateIf(o => o.is_malaysian === false)
    @IsNotEmpty({ message: 'validation.nationality_should_not_be_empty' })
    nationality: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @ValidateIf(o => o.is_malaysian === false)
    @IsNotEmpty({ message: 'validation.country_of_inssuance_should_not_be_empty' })
    country_inssuance: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @IsNotEmpty({ message: 'validation.date_of_birth_should_not_be_empty' })
    dob: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @IsNotEmpty({ message: 'validation.gender_should_not_be_empty' })
    gender: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @IsNotEmpty({ message: 'validation.race_should_not_be_empty' })
    race: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @IsEmail({}, { message: 'validation.email_is_not_valid' })
    @IsNotEmpty({ message: 'validation.email_should_not_be_empty' })
    email: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    phone_country: string = '+60';

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @Validate(PhoneValidatorConstraint)
    @IsNotEmpty({ message: 'validation.phone_number_should_not_be_empty' })
    phone_number: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @IsNotEmpty({ message: 'validation.please_select_one_option' })
    type: string;

    @IsBoolean({ message: 'validation.please_select_one_option' })
    is_malaysian: boolean;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @IsNotEmpty({ message: 'validation.please_select_one_option' })
    role: string;

}